export const toggleBottomSheet = (id) => {
    const bottomSheet = document.getElementById(`${id}__bottomSheet`);
    const content = bottomSheet.querySelector('.hds-o-bottomSheet__block');
    if (bottomSheet.classList.contains('hide')) {
        document.body.style.position = 'fixed';
        bottomSheet.classList.remove('hide');
        content.classList.add('slideInUp');
    }
    else {
        if (!bottomSheet.classList.contains('hide')) {
            content.classList.replace('slideInUp', 'slideOutDown');
            setTimeout(() => {
                bottomSheet.classList.add('hide');
                document.body.style.position = null;
                content.classList.remove('slideOutDown');
            }, 300);
        }
    }
};

//# sourceMappingURL=bottom-sheet-utils.js.map
